import React, { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import utils from "../../app/UtilityService";
import { ControlMessageGroup } from "@tinqin/tinqin-ui-components/src/control-messages";
import containerUtils from "../../utils/containerUtils";
import Paragraph from "@tinqin/tinqin-ui-components/src/paragraph/Paragraph";
import translationService from "../../app/TranslationService";

export const Notifications = function (props) {
    const [stateTimeouts, setStateTimeouts] = useState();

    const onClose = useCallback(
        (id) => {
            if (stateTimeouts && stateTimeouts[id]) {
                clearTimeout(stateTimeouts[id]);
            }
            props.removeNotification(id);
        },
        [props, stateTimeouts]
    );

    const buildEntities = useCallback(
        (content) => {
            return content.map((entity, index) => {
                let messageProps = containerUtils.extractComponentProps(
                    { data: { properties: entity } },
                    {
                        componentProps: ControlMessageGroup.propTypes,
                        aliases: { groupType: "type" },
                        propsDefaults: {
                            closable: true
                        },
                        skipDataTqId: true
                    }
                );
                //Defaulting 'name' based on type
                if (!messageProps.name && !messageProps.skipName) {
                    let labels = {
                        error: translationService.translate("errorGroupLabel"),
                        success: translationService.translate("successGroupLabel"),
                        warning: translationService.translate("warningGroupLabel"),
                        info: translationService.translate("infoGroupLabel"),
                        neutral: translationService.translate("neutralGroupLabel")
                    };
                    //Note: error is the default in tinqin-ui-components!
                    messageProps.name = labels[messageProps.groupType || "error"];
                }
                messageProps.onClose = () => {
                    onClose(entity.id);
                };
                let messages = entity.messages || [];
                messages = messages.map((message, i) => {
                    return <Paragraph key={i} text={message} />;
                });

                return (
                    <ControlMessageGroup key={index} {...messageProps}>
                        {messages}
                    </ControlMessageGroup>
                );
            });
        },
        [onClose]
    );

    useEffect(() => {
        if (stateTimeouts && props.content && props.content.length) {
            let timeouts = stateTimeouts || {};
            props.content.forEach((entity) => {
                if (!timeouts[entity.id]) {
                    timeouts[entity.id] = setTimeout(() => {
                        onClose(entity.id);
                    }, props.timeout);
                    setStateTimeouts(timeouts);
                }
            });
        }

        return () => {
            if (stateTimeouts) {
                let timeouts = stateTimeouts || {};
                Object.keys(timeouts).forEach((id) => {
                    clearTimeout(timeouts[id]);
                });
            }
        };
    });

    if (props.content && props.content.length) {
        let content = props.content || [];
        let entities = buildEntities(content);
        let className = "tq-float-alert-container";
        className += props.extraClasses ? " " + props.extraClasses : "";
        return <div className={className}>{entities}</div>;
    }

    return <></>;
};

Notifications.displayName = "Notifications";

export default connect(
    (state) => {
        return { notifications: state.getIn(["notifications"]) };
    },
    utils.getMapDispatchToProps({
        removeNotification: "messages.removeNotification"
    }),
    (state, dispatchProps, ownProps) => {
        return Object.assign({}, state.notifications.toJS(), dispatchProps, ownProps);
    }
)(Notifications);
